// extracted by mini-css-extract-plugin
export default {"container":"rating_container__PbUOx","count":"rating_count__IDs6o","icon":"rating_icon__rjB2T"};